import { ComponentProps, h } from 'preact';
import React from 'preact/compat';
import { CSSAttribute } from '../../types';

interface ArrowProps {
  className?: string;
  style?: CSSAttribute;
}

export function Arrow(props: ComponentProps<'svg'> & { ref?: React.Ref<SVGSVGElement> }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      ref={props.ref}
      {...props}
    >
      <path fill="currentColor" d="M5.859 4.125l2.156-2.109 9.984 9.984-9.984 9.984-2.156-2.109 7.922-7.875z" />
    </svg>
  );
}
